import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAlertTriangle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M7.843 7.7C9.207 5.337 9.89 4.156 10.78 3.76a3 3 0 0 1 2.44 0c.89.396 1.573 1.577 2.937 3.94l2.944 5.1c1.365 2.363 2.047 3.544 1.945 4.514a3 3 0 0 1-1.22 2.113c-.789.573-2.153.573-4.882.573H9.057c-2.729 0-4.093 0-4.881-.573a3 3 0 0 1-1.22-2.113c-.103-.97.58-2.151 1.944-4.514zm2.925 1.612a1.235 1.235 0 1 1 2.464 0l-.234 3.75a1 1 0 0 1-1.996 0zM12 14.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAlertTriangle)
export default ForwardRef
